import { gql } from '@apollo/client'

import { GROUP_FRAGMENT } from '../fragments'

export const GET_TENANT_GROUPS = gql`
  query GetTenantGroups {
    tenantGroups {
      results {
        ...Group
      }
    }
  }
  ${GROUP_FRAGMENT}
`
